export const SECTION_ADD_ENERGY_POINT_OPERATOR =
{'evcpo': { 'code':'pe_energy_point_operator_evcpo','description':'EV charging point operator'},
  'sespo':{'code':'pe_energy_point_operator_segpo','description':'Solar energy generation point operator'},
  'awgpo':{'code':'pe_energy_point_operator_awgpo','description':'Atmospheric water generation point operator'},
  'shdpo':{'code':'pe_energy_point_operator_shdpo','description':'Solar Humidification-Dehumidification point operator'},
  'wpgpo':{'code':'pe_energy_point_operator_wpgpo','description':'Wind power generation point operator'}
}

export const SECTION_EVCPSites='pe_company_evcp_site'